/**
 * Admin: Business page (spec 2026-07-22 §2.3).
 *
 * Tab shell for business identity + locations & hours. Commerce-gated;
 * sits beside (not inside) AppSettingsPage — that shell is platform/app
 * config, this is domain config with its own feature gate and RBAC.
 */

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui'
import { PageFrame } from '@/components/layout/PageFrame'
import { PageHeader } from '@/components/layout/PageHeader'
import { BusinessDetailsTab } from '@/pages/admin/business/BusinessDetailsTab'
import { BusinessLocationsTab } from '@/pages/admin/business/BusinessLocationsTab'

export function BusinessPage() {
  return (
    <PageFrame width="form" className="space-y-4">
      <PageHeader title="Business" subtitle="Business identity, locations, and pickup/delivery hours." />

      <Tabs defaultValue="details">
        <TabsList>
          <TabsTrigger value="details">Details</TabsTrigger>
          <TabsTrigger value="locations">Locations &amp; Hours</TabsTrigger>
        </TabsList>
        <TabsContent value="details" className="mt-4">
          <BusinessDetailsTab />
        </TabsContent>
        <TabsContent value="locations" className="mt-4">
          <BusinessLocationsTab />
        </TabsContent>
      </Tabs>
    </PageFrame>
  )
}
